<ion-header>
	<ion-toolbar>
		<ion-title>{{ 'payment.cancelled.title' | translate }}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="dismiss(false)">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<div class="payment-cancelled-content">
		<ion-icon name="warning-outline" class="warning-icon"></ion-icon>
		<p>{{ 'payment.cancelled.message' | translate }}</p>

		<div class="action-buttons">
			<ion-button fill="outline" (click)="dismiss(false)">
				{{ 'common.close' | translate }}
			</ion-button>
			<ion-button (click)="dismiss(true)">
				{{ 'payment.retry' | translate }}
			</ion-button>
		</div>
	</div>
</ion-content>
